/*
 * @Author: huangzq
 * @Date: 2020-04-13 20:47:21
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-12 15:12:52
 * @Desc: 完全通过数据生成的表单-常用的那种表单
*/
<template>
  <mk-form
    ref="dsFormBiz"
    class="ds-form-biz"
    :model="schema"
    v-bind="currGlobalConfig"
    v-on="$listeners"
  >
    <template v-for="(item, key) in schema">
      <mk-form-item
        :key="key"
        :prop="key+'.value'"
        v-bind="item.ui"
      >
        <!-- 通过提前注册好的组件名渲染组件 -->
        <component
          :is="item.ui.widget"
          v-model="item.value"
          v-bind="item.ui.widgetConfig"
          :placeholder="item.ui.placeholder"
          v-on="$listeners"
        />
      </mk-form-item>
    </template>

    <slot name="button" />
  </mk-form>
</template>

<script>
export default {
  name: 'DsSearch',
  model: {
    prop: 'formSchema',
    event: 'change'
  },
  props: {
    // 全局配置，表单 form
    globalConfig: {
      type: Object,
      default () {
        return {
          // 表单模式：横向表单，还是纵向表单
          inline: true,
          size: 'small'
        }
      }
    },
    // 表单配置数据
    // 基础组件封装
    // 自定义扩展组件封装
    formSchema: {
      type: Object,
      default () {
        return {
          // 基础类型
          // 字段名字：唯一性
          name: {
            // 当前字段类型
            type: 'string',
            // 当前字段的值，v-model使用
            value: '',
            // 当前字段的默认值，重置时使用
            defaultValue: '',
            // el-form-item的包含的组件，完全自定义的
            ui: {
              label: '课程名称',
              placeholder: '请输入名称',
              // 组件名
              widget: 'MkInput',
              // 组件配置
              widgetConfig: {
                width: '200'
              }
            }
          }
        }
      }
    }
  },
  data () {
    return {
      schema: {}
    }
  },

  computed: {
    // 当前的表单全局配置，融合了默认配置的
    currGlobalConfig () {
      const defaultGlobalConfig = {
        // 表单模式：横向表单，还是纵向表单
        inline: false,
        size: 'small'
      }
      const currGlobalConfig = {
        ...defaultGlobalConfig,
        ...this.$attrs,
        ...this.globalConfig
      }

      return currGlobalConfig
    }

  },
  watch: {
    formSchema () {
      this.handelData()
    }
  },
  mounted () {
    this.handelData()
  },
  methods: {
    handelData () {
      this.schema = this.formSchema
    },
    // 搜索事件
    handleOnSearchClick () {
      // 这里应该获取参数，进行传递
      let params = this.getParams()
      this.$emit('on-search-click', params)
    },
    // 重置事件
    handleOnResetClick () {
      // 这里应该清除选中的参数
      this.clearParams()
      let params = this.getParams()
      this.$emit('on-reset-click', params)
    },
    // 获取值，key:value的形式
    getParams () {
      let params = {}
      for (const key in this.schema) {
        if (this.schema.hasOwnProperty(key)) {
          params[key] = this.schema[key].value
        }
      }
      return params
    },
    // 将值全部处理为defaultValue
    clearParams () {
      for (const key in this.schema) {
        if (this.schema.hasOwnProperty(key)) {
          this.schema[key].value = this.schema[key].defaultValue
        }
      }
      return this.schema
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-form-biz {
  position: relative;

  /deep/.el-form-item--small.el-form-item {
    margin-bottom: 20px;
  }
}
</style>
